import { render, staticRenderFns } from "./BloodTypeBase.vue?vue&type=template&id=2700a455"
import script from "./BloodTypeBase.vue?vue&type=script&lang=js"
export * from "./BloodTypeBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports